<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="
			(setDialogHide) => {
				handleCloseDialog(setDialogHide, isFormDirty);
			}
		"
		class="custom-dialog"
		:visible.sync="isPopupActiveLocal"
	>
		<div slot="title">
			<h4 class="uppercase font-bold block text-xl w-full">Đánh giá vận đơn {{code}}</h4>
			<!-- <p class="text-base text-black font-medium">{{ data.device ? data.device.name : "" }}</p> -->
		</div>
		<!--<PerfectScrollbar ref="formScrollBar" class="scroll-area--data-list" :settings="settings">-->
		<div>
			<div class="p-6" v-if="isPopupActiveLocal">
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Nhà cung cấp
					</label>
					<cbs-input type="text" v-model="supplier_name" class="w-full" readOnly/>
				</div>
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Thời gian vận chuyển
					</label>
					<cbs-input type="text" v-model="shipping_date" class="w-full" readOnly/>
				</div>

				<vs-row class="mb-5">
					<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
						<div class="w-full pr-2">
							<label for class="text-base vs-input--label">
								Mã đơn bán
							</label>
							<cbs-input type="text" v-model="sell_id" class="w-full" readOnly/>
						</div>
					</vs-col>
					<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
						<div class="w-full pl-2">
							<label for class="text-base vs-input--label">
								Mã đơn mua
							</label>
							<cbs-input type="text" v-model="buy_id" class="w-full" readOnly/>
						</div>
					</vs-col>
				</vs-row>

				<vs-row class="mb-5" v-if="type_variant">
					<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
						<div class="w-full pr-2">
							<label for class="text-base vs-input--label">
								Số bao cá Y
							</label>
							<cbs-input type="text" v-model="so_bao_ca_y" class="w-full" readOnly/>
						</div>
					</vs-col>
					<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
						<div class="w-full pl-2">
							<label for class="text-base vs-input--label">
								Số bao cá dạt
							</label>
							<cbs-input type="text" v-model="so_bao_ca_dat" class="w-full" readOnly/>
						</div>
					</vs-col>
				</vs-row>

				<div class="mb-5" v-if="type_variant">
					<label for class="text-base vs-input--label">
						Quy cách đóng bao
					</label>
					<cbs-input type="text" v-model="packing_unit" class="w-full" readOnly/>
				</div>

				<vs-row class="mb-5" v-if="!type_variant">
					<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
						<div class="w-full pr-2">
							<label for class="text-base vs-input--label">
								Khối lượng (kg)
							</label>
							<cbs-input type="text" v-model="quantity" class="w-full" readOnly/>
						</div>
					</vs-col>
					<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
						<div class="w-full pl-2">
							<label for class="text-base vs-input--label">
								Số bao
							</label>
							<cbs-input type="text" v-model="num_packaging" class="w-full" readOnly/>
						</div>
					</vs-col>
				</vs-row>

				<vs-row class="mb-5">
					<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
						<div class="w-full pr-2">
							<label for class="text-base vs-input--label">
								Loại phương tiện
							</label>
							<cbs-input type="text" v-model="vehicle_type" class="w-full" readOnly/>
						</div>
					</vs-col>
					<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
						<div class="w-full pl-2">
							<label for class="text-base vs-input--label">
								Biển số
							</label>
							<cbs-input type="text" v-model="vehicle_no" class="w-full" readOnly/>
						</div>
					</vs-col>
				</vs-row>

				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Tài xế
					</label>
					<cbs-input type="text" v-model="driver_name" class="w-full" readOnly/>
				</div>

				<fieldset class="fieldset-custom mb-5" v-if="type_variant">
					<legend>Thống kê các loại cá:</legend>
					<vs-row>
						<vs-col vs-lg="4" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
							<div class="w-full pr-4">
								<label for class="text-base vs-input--label">
									Cá Y 300 up
								</label>
								<cbs-input type="text" v-model="khoi_luong_ca_y_300" class="w-full"/>
							</div>
						</vs-col>
						<vs-col vs-lg="4" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
							<div class="w-full pr-4">
								<label for class="text-base vs-input--label">
									Cá Y 400 up
								</label>
								<cbs-input type="text" v-model="khoi_luong_ca_y_400" class="w-full"/>
							</div>
						</vs-col>
						<vs-col vs-lg="4" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
							<div class="w-full">
								<label for class="text-base vs-input--label">
									Cá Y 500 up
								</label>
								<cbs-input type="text" v-model="khoi_luong_ca_y_500" class="w-full"/>
							</div>
						</vs-col>
					</vs-row>
					<vs-row>
						<vs-col vs-lg="4" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
							<div class="w-full pr-4">
								<label for class="text-base vs-input--label">
									Cá chết 300 up
								</label>
								<cbs-input type="text" v-model="khoi_luong_ca_chet_300" class="w-full"/>
							</div>
						</vs-col>
						<vs-col vs-lg="4" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
							<div class="w-full pr-4">
								<label for class="text-base vs-input--label">
									Cá chết 400 up
								</label>
								<cbs-input type="text" v-model="khoi_luong_ca_chet_400" class="w-full"/>
							</div>
						</vs-col>
						<vs-col vs-lg="4" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
							<div class="w-full">
								<label for class="text-base vs-input--label">
									Cá chết 500 up
								</label>
								<cbs-input type="text" v-model="khoi_luong_ca_chet_500" class="w-full"/>
							</div>
						</vs-col>
					</vs-row>
					<vs-row>
						<vs-col vs-lg="4" vs-sm="12" style="display: flex; vertical-align: middle;" class="mb-5">
							<div class="w-full pr-4">
								<label for class="text-base vs-input--label">
									Cá chết
								</label>
								<cbs-input type="text" v-model="khoi_luong_ca_dat" class="w-full"/>
							</div>
						</vs-col>
					</vs-row>
				</fieldset>

				<div class="mb-5" v-if="!type_variant">
					<label for class="text-base vs-input--label">
						Điểm đến
					</label>
					<cbs-input type="text" v-model="shipping_address" class="w-full" readOnly/>
				</div>
				<div v-if="canView">
					<div class="mb-5">
						<label for class="text-base vs-input--label">
							Địa điểm kho
						</label>
						<cbs-input type="text" v-model="storage_address" class="w-full" readOnly/>
					</div>
					<div class="mb-5">
						<label for class="text-base vs-input--label">
							Tên nhà cung cấp
						</label>
						<cbs-input type="text" v-model="supplier_name" class="w-full" readOnly/>
					</div>
					<div class="mb-5">
						<label for class="text-base vs-input--label"> Hình ảnh thực tế: </label>

						
						
						<div class="file-item" v-for="(file, index) in photos" :key="index">
							<img v-if="fileIsImage(file.extension)" class="responsive" :src="file.path" alt="" />
						</div>
						<span class="text-danger text-sm break-normal" v-show="errors.has('address')">{{ errors.first("address") }}</span>
					</div>
				</div>
				
				<div class="mb-5" style="overflow: hidden;" v-if="!type_variant">
					<vs-row class="mb-1" v-if="canRating">
						<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
							<vs-radio name="kcs_accept" v-model="kcs_accept" color="primary" id="kcs_accept" vs-value="1" />
							<label for="kcs_accept" class="text-base vs-input--label">
								Đạt chất lượng
							</label>
						</vs-col>
						<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
							<vs-radio name="kcs_reject" v-model="kcs_accept" color="primary" id="kcs_reject" vs-value="0" />
							<label for="kcs_reject" class="text-base vs-input--label">
								Chưa đạt
							</label>
						</vs-col>
					</vs-row>
				</div>
				<div class="mb-5 mt-5" v-if="canRating">
					<label for class="text-base vs-input--label">
						{{type_variant ? 'Ghi chú' : 'Lý do đạt hoặc chưa đạt'}}
					</label>
					<cbs-input type="text" v-model="kcs_note" class="w-full" name="kcs_note" :data-vv-as="'Điền vào'" :placeholder="`${$t('Input')} ${'Điền vào'}`" />
				</div>
				<div class="mb-5" v-if="price_variant && canRating">
					<label for class="text-base vs-input--label">
						Độ ẩm
					</label>
					<cbs-input type="number" v-model="humidity" class="w-full"/>
				</div>
				<vs-row v-if="canRating && !type_variant" class="mb-5">
					<vs-col vs-w="12" style="display: flex; vertical-align: middle;">
						<vs-checkbox name="has_return" v-model="has_return" color="primary" id="has_return" />
						<label for="has_return" class="text-base vs-input--label">
							Có trả hàng
						</label>
					</vs-col>
				</vs-row>

				<vs-row class="mb-5" v-if="canRating && !type_variant">
					<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
						<div class="w-full pr-2">
							<label for class="text-base vs-input--label">
								Số bao trả
							</label>
							<cbs-input type="text" v-model="return_quantity" class="w-full" name="return_quantity" :data-vv-as="'Số bao trả lại'" :placeholder="`${$t('Input')} ${'Số bao trả lại'}`" />
						</div>
					</vs-col>
					<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
						<div class="w-full pl-2">
							<label for class="text-base vs-input--label">
								KL bao trả (kg)
							</label>
							<cbs-input type="text" v-model="return_quantity_kg" class="w-full" name="return_quantity_kg" :data-vv-as="'Khối lượng bao trả (kg)'" :placeholder="`${$t('Input')} ${'Khối lượng bao trả (kg)'}`" />
						</div>
					</vs-col>
				</vs-row>

				<div class="mb-5" style="overflow: hidden;">
					<vs-row class="mb-1" v-if="canRating">
						<vs-col vs-w="4">
							<label class="text-solid-gray-1">Đánh giá nhà cung cấp:</label>
						</vs-col>
						<vs-col vs-w="8">
							<div class="flex">
								<i :style="{width: '40px', fontSize: '2rem', cursor: 'pointer', color: checkReview(supplier_rating, 1) ? '#F2994A' : '#828282'}" class="material-icons" v-on:click="changeReview(1)">star_rate</i>
								<i :style="{width: '40px', fontSize: '2rem', cursor: 'pointer', color: checkReview(supplier_rating, 2) ? '#F2994A' : '#828282'}" class="material-icons" v-on:click="changeReview(2)">star_rate</i>
								<i :style="{width: '40px', fontSize: '2rem', cursor: 'pointer', color: checkReview(supplier_rating, 3) ? '#F2994A' : '#828282'}" class="material-icons" v-on:click="changeReview(3)">star_rate</i>
								<i :style="{width: '40px', fontSize: '2rem', cursor: 'pointer', color: checkReview(supplier_rating, 4) ? '#F2994A' : '#828282'}" class="material-icons" v-on:click="changeReview(4)">star_rate</i>
								<i :style="{width: '40px', fontSize: '2rem', cursor: 'pointer', color: checkReview(supplier_rating, 5) ? '#F2994A' : '#828282'}" class="material-icons" v-on:click="changeReview(5)">star_rate</i>
							</div>
						</vs-col>
					</vs-row>
				</div>
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						 Hình ảnh
						<span class="text-danger">*</span>:
					</label>
					<!-- <cbs-upload-ref
						:key="timeKey"
						value="value"
						v-model="localAttachFile"
						accept="image/*"
						:limit="10"
						:on-exceed="() => $vs.notify({ title: $t('Notify.Notification'), text: $t('OnlyOneFileUpload') })"
					/> -->
					<CbsUploadRefCustom
						value="value"
						:key="timeKey2"
						v-model="localAttachFile"
						accept="image/*"
						:limit="10"
						:on-exceed="() => $vs.notify({ title: $t('Notify.Notification'), text: $t('OnlyOneFileUpload') })"
						:dataValue="files"
					/>
				</div>

				<div v-if="!type_variant" class="mb-5" :key="indextr" v-for="(tr, indextr) in packageValues">
					<label for class="text-base vs-input--label">
					{{packageMaps[indextr]}}
					</label>
					<cbs-input type="text" v-model="packageValues[indextr]" class="w-full"/>
				</div>
			</div>
		</div>
		<!--</PerfectScrollbar>-->

		<div class="flex justify-center">
			<span class="text-danger text-sm break-normal" v-show="customErrors != null">{{ customErrors }}</span>
		</div>

		<div class="flex justify-center" slot="footer" v-if="canRating">
			<vs-button class="w-full sm:w-1/3 font-bold" @click.stop="submitData" >Lưu lại</vs-button>
		</div>
	</el-dialog>
</template>
<script>
import * as _ from "lodash";
import vSelect from "vue-select";
import CbsDatePicker from "@/components/cbs-date-picker/CbsDatePicker.vue";
import CbsUploadRef from "@/components/cbs-upload-ref/CbsUploadRef";
import CbsUploadRefCustom from "@/components/cbs-upload-ref/CbsUploadRefCustom";

let latPos = 0, lngPos = 0;
let packageMaps = {
	package_50: 'Số bao 50kg',
	package_70: 'Số bao 70kg',
};

export default {
	name: "ShippingForm",
	components: { vSelect, CbsDatePicker, CbsUploadRef, CbsUploadRefCustom },
	props: {
		isPopupActive: {
			type: Boolean,
			required: true,
		},
		data: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			currentPhotos: [],
			kcs_detail: {},
			khoi_luong_ca_y_300: null,
			khoi_luong_ca_y_400: null,
			khoi_luong_ca_y_500: null,
			khoi_luong_ca_chet_300: null,
			khoi_luong_ca_chet_400: null,
			khoi_luong_ca_chet_500: null,
			khoi_luong_ca_dat: null,
			packing_unit: null,
			so_bao_ca_y: null,
			so_bao_ca_dat: null,
			type_variant: false,
			humidity: null,
			price_variant: false,
			packageMaps: packageMaps,
			packageValues: {
				package_50: null,
				package_70: null,
			},
			customErrors: null,
			timeKey: Date.now(),
			has_return: 1,
			shippingMethodTypes: [
				{
					id: 1,
					name: 'Xe tải'
				},
				{
					id: 2,
					name: 'Ghe'
				},
				{
					id: 4,
					name: 'Xe ba gác'
				},
			],
			sell_id: null,
			buy_id: null,
			canView: false,
			canRating: false,
			kcs_accept: null,
			shipping_date: null,
			vehicle_type: null,
			verhicle_no: null,
			driver_name: null,
			shipping_address: null,
			supplier_rating: 0,
			kcs_note: null,
			return_quantity: null,
			return_quantity_kg: 50,
			storage_address: null,
			supplier_name: null,
			num_packaging: null,
			lat: 0,
			lng: 0,


			timeKey: Date.now(),
			files: [],
			value: {},
			product: null,
			supplier: null,
			quantity: null,
			price: null,
			address: null,
			cus_note: null,

			// 'supplier_name': null,
            'supper_phone': null,
            'supper_mst': null,
            'supplier_bankaccount': null,
            'supplier_bankname': null,
            'supplier_bankowner': null,

			id: null,

			fullName: null,
			nickname: null,
			phone: null,
			city: null,
			district: null,
			ward: null,
			street: null,
			assigned: null,
			totalPool: null,
			code: null,
			photos: [],
			supplier_name: null,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() <= Date.now();
				}
			}
		};
	},
	watch: {
		kcs_accept(val) {
			console.log(val);
			if (parseInt(val) == 0) {
				this.has_return = 1;
			}
			// this.has_return = 1;
		},
		isPopupActive(val) {
			if (!val) return;

			try {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(position => {
						console.log('position: ', position);
						if (position.coords) {
							latPos = position.coords.latitude;
							lngPos = position.coords.longitude;
							console.log(latPos, lngPos);
						}
					});
				}
			} catch (exx) {
				console.log(exx.message);
			}

			console.log(this.data);

			// khoi_luong_ca_y_300: null,
			// khoi_luong_ca_y_400: null,
			// khoi_luong_ca_y_500: null,
			// khoi_luong_ca_chet_300: null,
			// khoi_luong_ca_chet_400: null,
			// khoi_luong_ca_chet_500: null,
			// khoi_luong_ca_dat: null,
			// packing_unit: null,
			// so_bao_ca_y: null,
			// so_bao_ca_dat: null,

			const { photos2, tested_date = null, packing_unit, so_bao_ca_y, so_bao_ca_dat, kcs_detail, type_variant, id , code, shipping_date, supplier_rating, vehicle_no, vehicle_type, quantity, kcs_accept, kcs_note, return_quantity, return_quantity_kg, driver_name, address, storage_address, supplier_name, photos = [], num_packaging, matching = {}, properties = {} } = this.data;
			const {sell_id, buy_id, product } = matching || {};
			const {price_variant} = product || {};
			this.price_variant = price_variant;
			if (photos2) {
				this.files = photos2;
			} else {
				this.files = [];
			}
			if (sell_id) {
				this.sell_id = sell_id;
			} else {
				this.sell_id = null;
			}
			if (packing_unit) {
				this.packing_unit = packing_unit;
			} else {
				this.packing_unit = null;
			}
			if (so_bao_ca_y) {
				this.so_bao_ca_y = so_bao_ca_y;
			} else {
				this.so_bao_ca_y = null;
			}
			if (so_bao_ca_dat) {
				this.so_bao_ca_dat = so_bao_ca_dat;
			} else {
				this.so_bao_ca_dat = null;
			}
			if (kcs_detail) {
				this.kcs_detail = kcs_detail;
				for (let k in kcs_detail) {
					this[k] = kcs_detail[k];
				}
			} else {
				this.kcs_detail = null;
			}
			if (supplier_name) {
				this.supplier_name = supplier_name;
			} else {
				this.supplier_name = null;
			}
			if (type_variant) {
				this.type_variant = type_variant;
			} else {
				this.type_variant = false;
			}
			if (code) {
				this.code = code;
			} else {
				this.code = null;
			}
			if (buy_id) {
				this.buy_id = buy_id;
			} else {
				this.buy_id = null;
			}

			if (photos) {
				this.photos = photos;
			}
			if (id) {
				this.id = id;
			} else {
				this.id = null;
			}
			if (shipping_date) {
				this.shipping_date = shipping_date;
			} else {
				this.shipping_date = null;
			}
			if (supplier_rating) {
				this.supplier_rating = supplier_rating;
			} else {
				this.supplier_rating = null;
			}
			if (vehicle_no) {
				this.vehicle_no = vehicle_no;
			} else {
				this.vehicle_no = null;
			}
			if (num_packaging) {
				this.num_packaging = num_packaging;
			} else {
				this.num_packaging = null;
			}
			if (vehicle_type) {
				this.vehicle_type = vehicle_type == 1 ? 'Xe tải' : (vehicle_type == 2 ? 'Ghe' : 'Xe ba gác');
			} else {
				this.vehicle_type = null;
			}
			if (quantity) {
				this.quantity = quantity;
			} else {
				this.quantity = null;
			}
			if (tested_date) {
				this.kcs_accept = kcs_accept ? '1' : '0';
			} else {
				this.kcs_accept = null;
			}
			// if (kcs_accept) {
			// 	this.kcs_accept = kcs_accept ? '1' : '0';
			// } else {
			// 	this.kcs_accept = '0';
			// }
			if (kcs_note) {
				this.kcs_note = kcs_note;
			} else {
				this.kcs_note = null;
			}
			if (return_quantity) {
				this.return_quantity = return_quantity;
				this.has_return = 1;
			} else {
				this.return_quantity = null;
				this.has_return = 0;
			}
			if (return_quantity_kg) {
				this.return_quantity_kg = return_quantity_kg;
			} else {
				this.return_quantity_kg = 50;
			}
			if (driver_name) {
				this.driver_name = driver_name;
			} else {
				this.driver_name = null;
			}
			if (address) {
				this.shipping_address = address;
			} else {
				this.shipping_address = null;
			}
			if (storage_address) {
				this.storage_address = storage_address;
			} else {
				this.storage_address = null;
			}
			console.log('Object.keys(properties).length: ', Object.keys(properties).length);
			if (properties && Object.keys(properties).length) {
				this.packageValues = properties;
				console.log('vao day nha');
			} else {
				console.log('day ne');
				for (let k in this.packageValues) {
					this.packageValues[k] = null;
				}
			}

			this.isFormDirty = false;
			this.initFormData = {};
		},

		computedFormData: {
			handler: function (newVal) {
				if (!this.isFormDirty && !_.isEqual(newVal, this.initFormData) && newVal.id === this.initFormData.id) {
					this.isFormDirty = true;
				}
			},
			deep: true,
		},
	},
	computed: {
		localAttachFile: {
			get() {
				// console.log('this.value: ' , this.value);
				return this.value.attachFile ? [this.value.attachFile] : [];
			},
			set(val) {
				// console.log('set.value: ' , val);
				// console.log(typeof val);
				if (val.length) {
					this.files = val;
				} else if (typeof val === 'number') {
					this.files.splice(val, 1);
				}
				if (this.files.length) {
					this.customErrors = null;
				}
				return this.$emit("input", { ...this.value, attachFile: val && val.length ? val[0] : null });
			}
		},
		isPopupActiveLocal: {
			get() {
				return this.isPopupActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closePopup");
				}
			},
		},
		computedFormData() {
			return {
				id: this.id,
				fullName: this.fullName,
				nickname: this.nickname,
				phone: this.phone,
				city: this.city,
				district: this.district,
				ward: this.ward,
				street: this.street,
				assigned: this.assigned,
				totalPool: this.totalPool,
			};
		},
	},
	created() {
		this.getSuppliers();
		
		if (this.$store.state.AppActiveUser) {
			let { permissions = {}, token } = this.$store.state.AppActiveUser;
			let { shipping_can_view = false, shipping_can_rating = false } = permissions;
			if (shipping_can_view) {
				this.canView = true;
			}
			if (shipping_can_rating) {
				this.canRating = true;
			}
			this.userToken = token;
		}
	},
	methods: {

		changeReview(num) {
			this.supplier_rating = num;
		},
		checkReview(review, num) {
			if (review) {
				return parseInt(review) >= num;
			}
			return false;
		},
		getSuppliers() {
			// this.$vs.loading();
			try {
				let payload = {
				};
				this.$store.dispatch("moduleProduct/fetchSuppliers", payload);
				this.getGetUsers();
				// this.$vs.loading.close();
			} catch (error) {
				console.log(error.message);
				// this.$vs.loading.close();
			}
		},
		handleChangeFile(uploadedFiles) {
			console.log('handleChangeFile: ', uploadedFiles);
			const uploadResult = uploadedFiles.map(file =>
				_.get(file, "response")
					? {
							id: file.response.id,
							path: file.response.path,
							file_name: file.response.file_name,
							extension: file.response.extension
					  } // eslint-disable-line no-mixed-spaces-and-tabs
					: file
			);

			this.value.attachFile = uploadResult && uploadResult.length ? uploadResult[0] : null;
		},
		initValues() {
			this.localAttachFile = [];
			this.timeKey = Date.now();
			this.quantity = null;
			this.price = null;
			this.supplier_name = null;
			this.supper_phone = null;
			this.supper_mst = null;
			this.supplier_bankaccount = null;
			this.supplier_bankname = null;
			this.supplier_bankowner = null;
			this.address = null;
			this.supplier = null;
			this.cus_note = null;
			this.$validator.reset();
		},
		submitData() {
			this.$validator.validateAll().then((result) => {
				let photoFiles = this.files.map(item => item.id);
				if (!photoFiles.length) {
					this.customErrors = 'Cần vài hình thực tế để lưu lại';
					return;
				}
				if (this.has_return && this.return_quantity < 1) {
					this.customErrors = 'Chưa nhập số bao trả lại';
					return;
				}
				let details = {};
				for (let k in this.kcs_detail) {
					details[k] = this[k] || 0;
				}
				if (result) {
					const dataObj = {
						id: this.id,
						kcs_accept: this.kcs_accept,
						kcs_note: this.kcs_note,
						supplier_rating: this.supplier_rating,
						lat: latPos,
						lng: lngPos,
						photos: photoFiles,
						packageValues: this.packageValues,
						return_quantity: this.return_quantity,
						return_quantity_kg: this.return_quantity_kg,
						humidity: this.humidity,
						kcs_detail: details,
					};
					console.log("[SUBMIT]", dataObj);

					this.handleCreateOrUpdate(dataObj);
				}
			});
		},
		handleCreateOrUpdateSuccess() {
			// if (this.supplier == 0) {
			// 	this.getSuppliers();
			// }
			// if (!this.id) {
			// 	this.initValues();
			// }
			// if (this.id) {
			// 	this.$emit("closePopup");
			// }
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: "Lưu thành công",
				},
			});
		},
		async handleCreateOrUpdate(dataObj) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("moduleProduct/kcsReviewShipping", dataObj);
				this.handleCreateOrUpdateSuccess();
			} catch (error) {
				console.log(error);
				this.$helper.notifyError({ context: this, options: {
					text: error,
				} });
			} finally {
				this.$vs.loading.close();
			}
		},

		getAddressCodeAndName(listData, code) {
			return _.find(listData, function (add) {
				return add.code === code;
			});
		},
	},
};
</script>


<style>
 .fieldset-custom {
	padding: 1rem;
    border: 1px solid rgba(0, 0, 0, 0.2);
 }
</style>